import { Component, Inject } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'app-add-serial-number-dialog',
    templateUrl: './add-serial-number-dialog.component.html',
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatDialogActions, MatButton, MatDialogClose]
})
export class AddSerialNumberDialogComponent {
  serialNumberInput = new FormControl<string>('', Validators.required);

  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
